module.exports = __webpack_public_path__ + "static/media/Sunflower_Image.545354a0.jpeg";